import { createSelector } from 'reselect';
import { getOriginSelector } from '../currentSearch/selectors';
import { getFilteredPreviousSearchesDestinationCities } from '../previousSearch/selectors';

const getTopDestinations = ({ topDestinations }) => topDestinations.topDestinations;

export const getTopDestinationsSelector = createSelector(
    [getTopDestinations, getOriginSelector],
    (topDestinations, origin) => {
        const originIata = origin ? origin.iata : null;
        return topDestinations.filter((dest) => dest.iata !== originIata);
    }
);

export const getTopDestinationsWithoutPreviousSearchesSelector = createSelector(
    [getTopDestinations, getFilteredPreviousSearchesDestinationCities, getOriginSelector],
    (topDestinations, previousSearchesCities, origin) => {
        const originIata = origin ? origin.iata : null;
        const previousSearchesList = previousSearchesCities.map(({ iata }) => iata);
        return topDestinations.filter((dest) => dest.iata !== originIata && !previousSearchesList.includes(dest.iata));
    }
);
